import { getParticipationStatus } from '../../../../backend/utils/shiftStateUtils';
import { ShiftRemainingTime } from '../../../../ui/components/ShiftRemainingTime';
import { Slots } from '../../../../ui/components/Slots';
import { getParticipationStatusBadgeLabel } from '../../../../ui/features/shift-details/utils';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip, Stack, Typography } from '@mui/material';
import React from 'react';
const DateAndTimeColumn = ({ row, accountParticipationIds, }) => {
    var _a;
    const { t } = useMissionsTranslation();
    const isInShift = (_a = row.approvedParticipantsIds) === null || _a === void 0 ? void 0 : _a.some((id) => accountParticipationIds.includes(id));
    return (React.createElement(Stack, { spacing: 1 },
        React.createElement(Typography, { variant: 'subtitle2' }, t('date', { value: row.startTime })),
        React.createElement(Typography, { variant: 'overline', sx: { color: themeColors.text.subtle } },
            t('time', { value: row.startTime }),
            " - ",
            t('time', { value: row.stopTime })),
        isInShift && (React.createElement(Chip, { size: 'small', sx: { width: 'fit-content', typography: 'caption' }, label: getParticipationStatusBadgeLabel(t, getParticipationStatus([{ status: 'approved' }])), color: 'success', "data-test": 'volunteer-status-chip' }))));
};
const CountyColumn = ({ row }) => {
    return React.createElement(Typography, { variant: 'subtitle2' }, row.county);
};
const VolunteersColumn = ({ row }) => {
    var _a, _b, _c;
    return React.createElement(Slots, { total: (_a = row.totalParticipantSlots) !== null && _a !== void 0 ? _a : 0, totalApproved: (_c = (_b = row.approvedParticipantsIds) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0 });
};
const TimeColumn = ({ row }) => {
    var _a;
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' } },
        React.createElement(ShiftRemainingTime, { startTime: (_a = row.startTime) !== null && _a !== void 0 ? _a : Date.now() })));
};
export function useVolunteerPastShiftsColumns(t, accountParticipationIds) {
    return React.useMemo(() => [
        {
            headerLabel: t('shifts.pastShiftsTable.dateAndTime'),
            cellFunction: (row) => React.createElement(DateAndTimeColumn, { row: row, accountParticipationIds: accountParticipationIds }),
        },
        {
            headerLabel: t('shifts.pastShiftsTable.county'),
            cellFunction: (row) => React.createElement(CountyColumn, { row: row }),
        },
        {
            headerLabel: t('shifts.pastShiftsTable.volunteers'),
            cellFunction: (row) => React.createElement(VolunteersColumn, { row: row }),
        },
        {
            headerLabel: t('shifts.pastShiftsTable.timeUntilShiftStart'),
            cellFunction: (row) => React.createElement(TimeColumn, { row: row }),
        },
    ], [t, accountParticipationIds]);
}
